import React from "react";
import { BingoCell } from "../../../types";
import "./PlayerCardModal.css";

interface PlayerCardModalProps {
  playerName: string;
  gridSize: number;
  cells: BingoCell[];
  onClose: () => void;
}

export const PlayerCardModal: React.FC<PlayerCardModalProps> = ({
  playerName,
  gridSize,
  cells,
  onClose,
}) => {
  return (
    <div className="player-card-modal" onClick={onClose}>
      <div
        className="player-card-modal__content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="player-card-modal__header">
          <h3>{playerName}s Bingo-Karte</h3>
          <button className="player-card-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="player-card-modal__board">
          <div
            className="player-card-modal__grid"
            style={{
              gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
              gridTemplateRows: `repeat(${gridSize}, 1fr)`,
            }}
          >
            {cells.map((cell) => (
              <div
                key={cell.id}
                className={`player-card-modal__cell ${
                  cell.marked ? "player-card-modal__cell--marked" : ""
                }`}
              >
                {cell.text}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
